/* eslint-disable max-len */
/* eslint-disable no-console */
import { Breadcrumbs } from '@mui/material';
import { BsFolder } from 'react-icons/bs';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LuFolderTree } from 'react-icons/lu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LanguageContext } from '../../../libs/Context';
import { useSelector } from 'react-redux';
import { getBreadCrumbs } from '../../actions/media_actions';
import { MediaContext } from '../../MediaDrive/index';
import MediaMenuItem from './MediaMenuItem';

const BreadCrumbComponent = (props:any) =>
{
	const { childFileList, empData, tab, getEmployeList } = props;
	const { language } = useContext(LanguageContext);
	const { setClickedData, setMediaState } = useContext(MediaContext);
	const navigate = useNavigate();
	const urlPath = useParams()?.tab || '';
	const parentId = useParams()?.id || '';
	const userId = useParams()?.userId || '';
	const path = window.location.pathname?.split('/')[2];
	const checkEdmPath = Boolean([ 'edit', 'design' ].includes(path));
	const folderId = useParams()?.folderId || '';
	const userData = useSelector((state: any) => state.mysession.session);

	const firstChildBreadCrumbs = childFileList?.length > 0 ? childFileList[0]?.parentPath : [];
	const [ breadCrumbs, setBreadCrumbs ] = useState(firstChildBreadCrumbs);
	const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () =>
	{
		setAnchorEl(null);
	};
	const handleNavigate = (id: string, item:any) =>
	{
		if (checkEdmPath) { return; }
		setMediaState({ type: 'breadCrumb' });
		setClickedData(item);
		!checkEdmPath && id && userId
			? navigate(`/drive/employee/${userId}/${id}`)
			: navigate(`/drive/${urlPath}/${id}`);
	};

	const handleMain = () =>
	{
		if (checkEdmPath) { return; }
		setMediaState({ type: 'breadCrumb' });
		userId
			? navigate('/drive/employee')

			: navigate(`/drive/${urlPath}`);

		userId && getEmployeList();
	};

	const getBreadCrumbsFunc = async () =>
	{
		const query = { uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			id     	: checkEdmPath ? folderId : parentId
		};

		try
		{
			const res = await getBreadCrumbs(query);

			if (res?.status)
			{
				setBreadCrumbs(res?.data);
			}
		}
		catch (err)
		{
			setMediaState({ type: 'updateReducer', payload: { loading: false } });

			console.log('error', err);
		}
	};

	useEffect(() =>
	{
		tab === 2 && parentId && userId && getBreadCrumbsFunc();
		[ 0, 1 ].includes(tab) && getBreadCrumbsFunc();
	}, [ parentId ]);

	const handleEmp = () =>
	{
		setBreadCrumbs([]);
		navigate(`/drive/employee/${empData?.userId}`);
	};

	const handleKeyUp = (e, ind, bread) =>
	{
		if (e.key === 'Enter')
		{
			if (breadCrumbs.length !== ind + 1)
			{
				handleNavigate(bread?.id, bread);
			}
		}
	};

	return (
		<>
			<div className='flexAutoRow pointer'>
				<button onKeyUp={(e) => { e.key === 'Enter' && handleClick(e); }} className='flexInline alignCntr' onClick={handleClick}>
					<LuFolderTree fontSize={'var(--pixel20)'} className='primaryTxt mrgnRXXS' />{' '}
					<ArrowDropDownIcon />
				</button>
			</div>
			<span className='pdngHXS'> | </span>
			<MediaMenuItem
				anchorEl={anchorEl}
				handleClose={handleClose}
				breadCrumbs={breadCrumbs}
				handleMain={handleMain}
				open={open}
				handleNavigate={handleNavigate}
				type='common'
			/>
			<Breadcrumbs
				maxItems={3}
				itemsAfterCollapse={2}
				aria-label='breadcrumb'
				className='flexWrap alignCntr navWidth'
			>
				<button
					tabIndex={0}
					onKeyUp={(e) => { e.key === 'Enter' && handleMain(); }}
					className='flexInline alignStart breadCrumbTxt pointer headingSM'
					onClick={handleMain}
				>
					<BsFolder fontSize={'var(--pixel24)'} className='primaryTxt mrgnRXS' />
					{language.main}
				</button>
				{tab === 2 && empData?.ownerName !== '' &&
				<button
					tabIndex={0}
					onKeyUp={(e) => { e.key === 'Enter' && handleEmp(); }}
					className={`flexInline alignStart headingSM ${breadCrumbs?.length > 0 ? 'breadCrumbTxt pointer' : 'lightTxt'}`}
					onClick={handleEmp}
				>
					{empData?.ownerName}
				</button>}
				{breadCrumbs?.map((bread, ind) => (
					<button
						key={bread?.id}
						id={bread?.id}
						onKeyUp={(e) => handleKeyUp(e, ind, bread)}
						onClick={
							breadCrumbs.length !== ind + 1
								? () => handleNavigate(bread?.id, bread)
								: () => {}
						}
						className={`flexInline mediakit-breadcumb headingSM ${
							ind !== breadCrumbs?.length - 1
								? ' breadCrumbTxt pointer'
								: 'lightTxt'
						}`}
					>
						{bread?.name?.length > 50
							? `${bread?.name?.slice(0, 50)}...`
							: bread?.name}
					</button>
				))}
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbComponent;
